
import Title from '~/components/specialist/section-title.vue'

export default {
  name: 'SpecialistKv',
  components: {
    Title
  }
}
